import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // 14 minutes and 50 seconds = 890 seconds
  const [timeLeft, setTimeLeft] = useState(890);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 0) {
          return 890; // Reset to 14:50
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  return <span className="font-mono font-bold tracking-wider" data-id="element-2">
      {minutes}:{seconds}
    </span>;
}